module.exports = __webpack_public_path__ + "static/media/b1.9c4ab406.jpg";